// ThemeProvider.js
import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, StyledEngineProvider } from '@mui/material/styles';
// Emotion pour RTL
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
//
import GlobalStyles from './globalStyles';
import createAppTheme from '../theme';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.oneOf(['ltr', 'rtl']),
};

export default function ThemeProvider({ children, direction = 'ltr' }) {
  // 1️⃣ Crée le cache Emotion pour RTL
  const cacheRtl = useMemo(
    () =>
      createCache({
        key: direction === 'rtl' ? 'mui-rtl' : 'mui',
        stylisPlugins: direction === 'rtl' ? [rtlPlugin] : [],
      }),
    [direction]
  );

  // 2️⃣ Crée le thème complet avec overrides
  const theme = useMemo(() => createAppTheme(direction), [direction]);

  return (
    <CacheProvider value={cacheRtl}>
      <StyledEngineProvider injectFirst>
        <MUIThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles />
          {children}
        </MUIThemeProvider>
      </StyledEngineProvider>
    </CacheProvider>
  );
}
